import Vue from 'vue';
import Router from 'vue-router';

import withUser from '~lib/common/hoc/withUser';

import Cases from '../screens/Cases.vue';
import CaseEditor from '../screens/Editor.vue';
import CaseBuilder from '../screens/Builder.vue';
import Grades from '../screens/Grades.vue';
import Assignments from '../screens/Assignments.vue';
import AssignmentList from '../components/assignments/AssignmentList';
import AssignmentEditor from '../components/assignments/AssignmentEditor';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/authoring',
  routes: [
    {
      path: '/cases',
      name: 'cases',
      component: withUser()(Cases),
    },
    {
      path: '/cases/new',
      name: 'case-builder',
      component: CaseBuilder,
    },
    {
      path: '/cases/edit/:id?',
      name: 'case-editor',
      component: CaseEditor,
    },
    {
      path: '/cases/grades/:id?',
      name: 'grades',
      component: Grades,
    },
    {
      path: '/assignments',
      component: Assignments,
      children: [
        {
          path: '/',
          name: 'assignment-list',
          component: AssignmentList,
        },
        {
          path: 'edit/:assignmentId?',
          name: 'assignment-editor',
          component: AssignmentEditor,
        },
      ],
    },
  ],
});
